import { randomLong } from './random';

const GA_DOMAIN_COMPONENTS = 2;

export function generateGaCookie(tsSeconds: number): string {
  return `GA1.${GA_DOMAIN_COMPONENTS}.${randomLong()}.${tsSeconds}`;
}
